<div class="dash-card" [class.dash-card--favorite]="layout === 'favorite'" (click)="openProject()">
  <div class="dash-card__header">
    <div class="dash-card__asset" [title]="project.Asset?.Name">
      {{ assetLabel }}
    </div>
    <div class="dash-card__header-actions" (click)="$event.stopPropagation()">
      <button *ngIf="isFavoriteEnabled" type="button" class="star-btn"
        (click)="toggleFavorite($event, project)"
        title="{{ isProjectFavorited(project.ProjectId) ? 'Remove from favorites' : 'Add to favorites' }}">
        <fa-icon [icon]="faStar" [class.is-favorited]="isProjectFavorited(project.ProjectId)"></fa-icon>
      </button>
      <div class="card-menu" [class.open]="menuOpen">
        <button type="button" class="menu-trigger" title="More options" (click)="toggleMenu($event)">
          <fa-icon [icon]="faEllipsisV"></fa-icon>
        </button>
        <div class="card-menu__dropdown" *ngIf="menuOpen" (click)="$event.stopPropagation()">
          <button *ngIf="showEditIconForUser" type="button" class="card-menu__item" (click)="editProject($event)">
            Edit Project
          </button>
          <button type="button" class="card-menu__item" (click)="openInProPak($event)">
            Open Project in ProPak
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="dash-card__title" [title]="project.Name">{{ project.Name }}</div>

  <div class="status-pill" [ngClass]="'status-pill--' + statusTone">
    <fa-icon [icon]="statusIcon"></fa-icon>
    <span>{{ statusLabel }}</span>
  </div>

  <div class="dash-card__metrics">
    <div class="metric" *ngFor="let metric of metrics">
      <div class="metric__label">{{ metric.label }}</div>
      <ng-container *ngIf="showMetricSkeleton; else metricLoaded">
        <div class="metric__skeleton-value"></div>
        <div class="metric__bar metric__bar--skeleton"></div>
      </ng-container>
      <ng-template #metricLoaded>
        <div class="metric__value" [class.is-empty]="metric.value == null" [ngClass]="'tone-' + metric.tone">
          {{ metric.display }}
        </div>
        <div class="metric__bar">
          <span [style.width.%]="metric.value || 0" [ngClass]="'tone-' + metric.tone"></span>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="dash-card__metrics-stale" *ngIf="metricsAreStale" role="status" aria-live="polite">
    <fa-icon [icon]="faSpinner" [spin]="true"></fa-icon>
    <span>{{ metricsAsOfLabel }}</span>
  </div>
</div>
